import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { cloneDeep } from 'lodash';
import { FormGroup, FormControlLabel, Checkbox } from 'components';
import styles from './CheckBoxPreview.scss';

const CheckBoxPreview = ({ defaultValue, isDisabled, onChange, ...checkboxProps }) => {
    const [items, setItems] = useState(defaultValue);

    const handleSelectItem = (index) => {
        const updatedItem = { ...items[index] };
        updatedItem.checked = !updatedItem.checked;
        const updatedItems = cloneDeep(items);
        updatedItems[index] = updatedItem;
        onChange(updatedItems);
        setItems(updatedItems);
    };

    return (
        <FormGroup className={styles.formGroup}>
            {
                items.map((item, index) =>
                    <FormControlLabel
                        key={item.index}
                        value={item.item}
                        control={
                            <Checkbox
                                color='primary'
                                checked={item.checked}
                                onChange={() => handleSelectItem(index)}
                                { ...checkboxProps }
                            />
                        }
                        label={<div className={styles.label}>{item.item}</div>}
                        disabled={isDisabled}
                    />
                )
            }
        </FormGroup>
    );
};

CheckBoxPreview.propTypes = {
    defaultValue: PropTypes.arrayOf(
        PropTypes.shape({
            index: PropTypes.string,
            item: PropTypes.string,
            checked: PropTypes.bool
        })
    ).isRequired,
    isDisabled: PropTypes.bool,
    onChange: PropTypes.func
};

CheckBoxPreview.defaultProps = {
    isDisabled: false,
    onChange: () => {}
};

export default CheckBoxPreview;

